/** Local emulator endpoints from firebase.json — use 127.0.0.1, not localhost. */
export const EMULATOR_HOST = "127.0.0.1";
export const EMULATOR_PORTS = {
  auth: 9099,
  firestore: 8080,
  storage: 9199,
  functions: 5001,
} as const;

export let usingFirebaseEmulators = false;

const PROBE_TIMEOUT_MS = 400;

/** True when VITE_USE_EMULATORS=1 and the Auth emulator responds on :9099. */
export function wantsEmulators(): boolean {
  return (
    import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === "1" && !import.meta.env.VITEST
  );
}

export async function probeAuthEmulator(timeoutMs = PROBE_TIMEOUT_MS): Promise<boolean> {
  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    const res = await fetch(`http://${EMULATOR_HOST}:${EMULATOR_PORTS.auth}/`, {
      signal: controller.signal,
    });
    clearTimeout(timer);
    if (!res.ok) return false;
    const body: unknown = await res.json();
    return (
      typeof body === "object" &&
      body !== null &&
      (body as { authEmulator?: { ready?: unknown } }).authEmulator?.ready === true
    );
  } catch {
    return false;
  }
}

/** Sets `usingFirebaseEmulators` when the suite is reachable. */
export async function initFirebaseEmulatorProbe(): Promise<boolean> {
  if (!wantsEmulators()) {
    usingFirebaseEmulators = false;
    return false;
  }
  usingFirebaseEmulators = await probeAuthEmulator();
  return usingFirebaseEmulators;
}
